import React from 'react';
import UrlConstants from '../../constants/UrlConstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Container, Grid, MenuItem, Paper, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { createStyles, makeStyles } from '@mui/styles';
import IMenuItem from '../../interfaces/common/menuItem';
import MainLayout from '../common/widgets/mainLayout';
import { Theme } from '@mui/material';
import LanguageUtils from '../../utils/LanguageUtils';
import { FormattedMessage, useIntl } from 'react-intl';
import { hasRoles } from '../../utils/roleUtils';
import RoleConstants from '../../constants/roleConstants';
import { useSelector } from 'react-redux';
import { getUserDetails } from '../../reducers/userReducer';

const messages = {
    ordersNotYetInvoiced: LanguageUtils.createMessage('Orders not invoiced'),
    provisions: LanguageUtils.createMessage('Provisions'),
    kickbackAgreement: LanguageUtils.createMessage('kickback Agreement'),
    reports: LanguageUtils.createMessage('Reports'),
    reportHeaderPivoted: LanguageUtils.createMessage('Report Header Pivoted'),
    reportCustomerTerms: LanguageUtils.createMessage('Report Customer Terms'),
    scheduledJob: LanguageUtils.createMessage('Scheduled job'),
    reportHeader004: LanguageUtils.createMessage('Report Header004'),
    reportHeader005: LanguageUtils.createMessage('Report Header005')

};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            padding: theme.spacing(4)
        },
        link: {
            textDecoration: 'none',
            color: `${theme.palette.info.main}!important`,
            fontSize: '12px!important'
        },
        typography: {
            fontSize: '8.5px!important',
            textTransform: 'uppercase',
            color: 'black'
        }
    })
);

export default function Reports(): JSX.Element {

    const { formatMessage } = useIntl();
    const classes = useStyles();
    const user = useSelector(getUserDetails);

    const isAdmin = hasRoles([RoleConstants.Roles.ROLE_ADMIN], user.roles);

    return (
        <MainLayout
            menuItem={{} as IMenuItem}
        >
            <Container maxWidth="xl" className={classes.container}>
                <Paper>
                    <Grid container spacing={3}>
                        <Grid item>
                            <Button color="info" component={NavLink} exact
                                to={`/${UrlConstants.ORDER_NOT_YET_INVOICED}`} title={formatMessage(messages.ordersNotYetInvoiced)}
                            >
                                <MenuItem>
                                    <Grid container direction="column" alignItems="center">
                                        <Grid item>
                                            <FontAwesomeIcon icon="warehouse" size="3x" transform="shrink-2" />
                                        </Grid>
                                        <Typography variant="caption" textAlign="center" className={classes.typography}>
                                            <FormattedMessage {...messages.ordersNotYetInvoiced} /></Typography>
                                    </Grid>
                                </MenuItem>
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button color="info" component={NavLink} exact
                                to={`/${UrlConstants.PROVISIONS}`} title={formatMessage(messages.provisions)}
                            >
                                <MenuItem>
                                    <Grid container direction="column" alignItems="center">
                                        <Grid item>
                                            <FontAwesomeIcon icon="table" size="3x" transform="shrink-2" />
                                        </Grid>
                                        <Typography variant="caption" textAlign="center" className={classes.typography}>
                                            <FormattedMessage {...messages.provisions} /></Typography>
                                    </Grid>
                                </MenuItem>
                            </Button>
                        </Grid>
                        {(isAdmin) &&
                            <Grid item>
                                <Button color="info" component={NavLink} exact
                                    to={`/${UrlConstants.KICKBACK_AGREEMENT_POSTEN}`} title={formatMessage(messages.kickbackAgreement)}
                                >
                                    <MenuItem>
                                        <Grid container direction="column" alignItems="center">
                                            <Grid item>
                                                <FontAwesomeIcon icon="chart-bar" size="3x" transform="shrink-2" />
                                            </Grid>
                                            <Typography variant="caption" textAlign="center" className={classes.typography}>
                                                <FormattedMessage {...messages.kickbackAgreement} /></Typography>
                                        </Grid>
                                    </MenuItem>
                                </Button>
                            </Grid>}
                        <Grid item>
                            <Button color="info" component={NavLink} exact
                                to={`/${UrlConstants.REPORT_HEADER_PIVOTED}`} title={formatMessage(messages.reportHeaderPivoted)}
                            >
                                <MenuItem>
                                    <Grid container direction="column" alignItems="center">
                                        <Grid item>
                                            <FontAwesomeIcon icon="chart-line" size="3x" transform="shrink-2" />
                                        </Grid>
                                        <Typography variant="caption" textAlign="center" className={classes.typography}>
                                            <FormattedMessage {...messages.reportHeaderPivoted} /></Typography>
                                    </Grid>
                                </MenuItem>
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button color="info" component={NavLink} exact
                                to={`/${UrlConstants.REPORT_CUSTOMER_TERMS}`} title={formatMessage(messages.reportCustomerTerms)}
                            >
                                <MenuItem>
                                    <Grid container direction="column" alignItems="center">
                                        <Grid item>
                                            <FontAwesomeIcon icon="receipt" size="3x" transform="shrink-2" />
                                        </Grid>
                                        <Typography variant="caption" textAlign="center" className={classes.typography}>
                                            <FormattedMessage {...messages.reportCustomerTerms} /></Typography>
                                    </Grid>
                                </MenuItem>
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button color="info" component={NavLink} exact
                                to={`/${UrlConstants.REPORT_HEADER_004}`} title={formatMessage(messages.reportHeader004)}
                            >
                                <MenuItem>
                                    <Grid container direction="column" alignItems="center">
                                        <Grid item>
                                            <FontAwesomeIcon icon="chart-bar" size="3x" transform="shrink-2" />
                                        </Grid>
                                        <Typography variant="caption" textAlign="center" className={classes.typography}>
                                            <FormattedMessage {...messages.reportHeader004} /></Typography>
                                    </Grid>
                                </MenuItem>
                            </Button>
                        </Grid>
                        {/* <Grid item>
                            <Button color="info" component={NavLink} exact
                                to={`/${UrlConstants.REPORT_HEADER_005}`} title={formatMessage(messages.reportHeader005)}
                            >
                                <MenuItem>
                                    <Grid container direction="column" alignItems="center">
                                        <Grid item>
                                            <FontAwesomeIcon icon="chart-line" size="3x" transform="shrink-2" />
                                        </Grid>
                                        <Typography variant="caption" textAlign="center" className={classes.typography}>
                                            <FormattedMessage {...messages.reportHeader005} /></Typography>
                                    </Grid>
                                </MenuItem>
                            </Button>
                        </Grid> */}
                    </Grid>
                </Paper>
            </Container>
        </MainLayout>
    );
}
